
<div class="recent-numbers-container" data-role="roulette-statistics-container">
  <div v-for="(result, index) in results" :key="index" class="box" :result="result">
    <div v-if="isCaseDouble(result)" :class="getClass(result)">
      <div :class="getCouleur(splitValeur(result)[0])">{{ splitValeur(result)[0] }}</div>
      <div v-if="!isJackpot(result)" :class="getCouleur(splitValeur(result)[1])">
        {{ splitValeur(result)[1] }}
      </div>
    </div>
    <div
      v-else
      class="game-result"
      :class="[getCouleur(result), { lucky: getLuckyNumber(index) }]"
    >
      {{ result }}
      <div v-if="getLuckyNumber(index)" class="multiplier" data-role="multiplier">
        {{ getLuckyNumber(index) }}x
      </div>
    </div>
  </div>
</div>
